export const IS_LOADING = 'IS_LOADING';
export const PROPERTIES_ACTIONS = {
  SET_PROPERTIES: 'SET_PROPERTIES',
  SELECTED_PROPERTY: 'SELECTED_PROPERTY',
  SELECTED_BEDROOM: 'SELECTED_BEDROOM',
  SELECTED_MARKET: 'SELECTED_MARKET',
};

export const RENEWAL_OFFERS_ACTIONS = {
  UPDATE_SUMMARY_DATA: 'UPDATE_SUMMARY_DATA',
};

export const RENEWAL_DASHBOARD_DATA = {
  SET_DATA: 'SET_DATA',
};

export const TENANT_ACTIONS = {
  TNT_LOADING: 'TNT_LOADING',
  SET_TNT_DATERANGE: 'SET_TNT_DATERANGE',
  SET_SELECTED_SEGMENT: 'SET_SELECTED_SEGMENT',
  SET_SELECTED_GROUP: 'SET_SELECTED_GROUP',
  GET_AREA_SEGMENTS: 'GET_AREA_SEGMENTS',
  GET_SEGMENT_FACTORS: 'GET_SEGMENT_FACTORS',
  GET_GROUPED_TENANTS: 'GET_GROUPED_TENANTS',
  GET_KEY_METRICS: 'GET_KEY_METRICS',
};

export const STRATEGY_ACTIONS = {
  LOADING: 'LOADING',
  SET_CARD: 'SET_CARD',
  SET_STRATEGY: 'SET_STRATEGY',
  FETCH_DATA: 'FETCH_DATA',
  FETCH_AUTO_APPROVE: 'FETCH_AUTO_APPROVE',
  UPDATE_AUTO_APPROVE: 'UPDATE_AUTO_APPROVE',
  SAVED: 'SAVED',
  NOT_SAVED: 'NOT_SAVED',
  SET_SELECTED_PROPERTY: 'SET_SELECTED_PROPERTY',
  SET_SELECTED_MARKET: 'SET_SELECTED_MARKET',
};

export const SETTINGS_ACTIONS = {
  SET_OFFER_GENERATION_STATUS: 'SET_OFFER_GENERATION_STATUS',
  CLEAR_OFFER_GENERATION_STATUS: 'CLEAR_OFFER_GENERATION_STATUS',
  GET_CUSTOM_STRATEGY_PARAMETERS: 'GET_CUSTOM_STRATEGY_PARAMETERS',
  CREATE: 'CREATE',
  SAVE: 'SAVE',
  RESET: 'RESET',
  NOT_SAVE: 'NOT_SAVE',
  FETCH_DATA: 'FETCH_DATA',
  FETCH_STRATEGIES: 'FETCH_STRATEGIES',
  SET_PROPERTY: 'SET_PROPERTY',
  SET_STRATEGY_PROPERTY: 'SET_STRATEGY_PROPERTY',
  LOADING: 'LOADING',
  FETCH_USERS: 'FECH_USERS',
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_USER_FAILED: 'UPDATE_USER_FAILED',
  UPDATE_GENERAL: 'UPDATE_GENERAL',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
  UPDATE_RULES_ENGINE: 'UPDATE_RULES_ENGINE',
  UPDATE_SETTINGS_FAILED: 'UPDATE_SETTINGS_FAILED',
  FETCH_RULES_ENGINE_DATA: 'FETCH_RULES_ENGINE_DATA',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  FETCH_SCHEDULED_REPORTS: 'FETCH_SCHEDULED_REPORTS',
  UPDATE_SCHEDULED_REPORT: 'FETCH_SCHEDULED_REPORT',
  FETCH_MARKET_RENT_DATA: 'FETCH_MARKET_RENT_DATA',
  UPDATE_MARKET_RENT_DATA: 'UPDATE_MARKET_RENT_DATA',
  GENERATE_RENEWAL_OFFERS: 'GENERATE_RENEWAL_OFFERS',
  GENERATE_NEW_LEASE_OFFERS: 'GENERATE_NEW_LEASE_OFFERS',
  SET_MARKET_RENT_OFFER_GENERATION_STATUS:
    'SET_MARKET_RENT_OFFER_GENERATION_STATUS',
  CLEAR_MARKET_RENT_OFFER_GENERATION_STATUS:
    'CLEAR_MARKET_RENT_OFFER_GENERATION_STATUS',
  /*
    FETCH_STRATEGY_DATA: 'FETCH_STRATEGY_DATA',
  //////////////////////////////////////////////
  GET_CUSTOM_STRATEGY_PARAMETERS: 'GET_CUSTOM_STRATEGY_PARAMETERS',
  GET_STRATEGY: 'GET_STRATEGY',
  GET_STRATEGY_PARAMETERS: 'GET_STRATEGY_PARAMETERS',
  CLEAR_STRATEGY_DATA: 'CLEAR_STRATEGY_DATA',
  FETCH_SCHEDULED_REPORTS: 'FETCH_SCHEDULED_REPORTS',
  UPDATE_SCHEDULED_REPORT: 'FETCH_SCHEDULED_REPORT',
  */
};

export const UPLOAD_TO_PMS_ACTIONS = {
  UPLOAD: 'UTPA_UPLOAD',
  OPEN: 'UTPA_OPEN',
  CLOSE: 'UTPA_CLOSE',
  IS_LOADING: 'UTPA_ISLOADING',
  FETCH: 'UTPA_FETCH',
  CLEAR: 'UTPA_CLEAR',
  SET_REFRESH_FUNC_PARAM: 'UTPA_SET_REFRESH_FUNC_PARAM',
  SET_NEW_LEASE_TASK_EXECUTION_STATUS:
    'UTPA_SET_NEW_LEASE_TASK_EXECUTION_STATUS',
  SET_RENEWAL_TASK_EXECUTION_STATUS: 'UTPA_SET_RENEWAL_TASK_EXECUTION_STATUS',
  SET_NEW_LEASE_UPLOAD_OFFER_LOGS: 'UTPA_SET_NEW_LEASE_UPLOAD_OFFER_LOGS',
  SET_RENEWAL_UPLOAD_OFFER_LOGS: 'UTPA_SET_RENEWAL_UPLOAD_OFFER_LOGS',
};
